document.addEventListener("DOMContentLoaded", () => {
  const tabTitles = document.querySelectorAll(".tab-title");
  const tabContents = document.querySelectorAll(".tab-content");

  if (!tabTitles.length || !tabContents.length) {
    console.error("Tab elements not found! Check HTML structure.");
    return;
  }

  tabTitles.forEach((title) => {
    title.addEventListener("click", () => {
      const target = title.getAttribute("data-tab");

      // Remove 'active' class from all tabs and contents
      tabTitles.forEach((item) => item.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add 'active' class to the clicked tab and its content
      title.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});